import React from 'react';
import CardBody from 'components/Card/CardBody';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/changePasswordDialogStyle';
import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import ErrorBox from 'components/ErrorBox/ErrorBox';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomInput from 'components/CustomInput/CustomInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import { COUNTRY_CODE } from 'utils/const/numbers';

interface FormData {
	newNumber: string;
}

interface IFormProps {
	formData: FormData;
	onChange: (name: keyof FormData, value: string) => void;
	isValid: boolean;
	isSameContactNumber: boolean;
	isResetSuccessful: boolean;
	isNewDashBoardEnabled?: boolean;
	changeNumberLabels?: { [key: string]: string };
}

//@ts-ignore
const useStyles = makeStyles(styles);

const Form = (props: IFormProps) => {
	const {
		formData,
		onChange,
		isResetSuccessful,
		isNewDashBoardEnabled,
		changeNumberLabels,
		isSameContactNumber,
	} = props;
	const classes = useStyles({ isNewDashBoardEnabled });

	const headerText = (
		<BodyM color="primary-light" customClassName={classes.modalSubtitle}>
			{isNewDashBoardEnabled ? changeNumberLabels?.header : translate('change.number.form.body')}
		</BodyM>
	);

	const loginUnsuccessfulText = (
		<div className={classes.loginUnsuccessful}>
			<ErrorBox text={translate('change.number.unsuccessfulNumberChange')} />
		</div>
	);

	return (
		<form
			style={{ maxWidth: isNewDashBoardEnabled ? '100%' : '300px' }}
			onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
				event.preventDefault();
			}}
		>
			<ConditionalRender
				show={isResetSuccessful}
				onTrue={() => headerText}
				onFalse={() => loginUnsuccessfulText}
			/>
			<CustomInput
				labelText={
					isNewDashBoardEnabled ? changeNumberLabels?.numberLabel : translate('change.number.new.number')
				}
				id="newNumber"
				inputProps={{
					required: true,
					value: formData.newNumber,
					type: 'number',
					onChange: (event: React.FormEvent<HTMLInputElement>) =>
						onChange('newNumber', (event.target as HTMLInputElement).value),
					placeholder: isNewDashBoardEnabled ? changeNumberLabels?.placeholder : '',
					startAdornment: isNewDashBoardEnabled ? (
						<InputAdornment position="start" className={classes.countryCode}>
							{COUNTRY_CODE}
						</InputAdornment>
					) : null,
				}}
				formControlProps={{
					fullWidth: true,
				}}
				isNewDashBoardEnabled={isNewDashBoardEnabled}
				variant={isNewDashBoardEnabled ? 'outlined' : ''}
			/>
			{isSameContactNumber && <ErrorBox text={changeNumberLabels?.error_same_phone_number ?? ''} />}
		</form>
	);
};

const ChangeNumberTab = (props: IFormProps) => {
	//@ts-ignore
	const classes = makeStyles(styles)({ isNewDashBoardEnabled: props.isNewDashBoardEnabled });
	return (
		<CardBody className={classes.cardBody}>
			<Form
				formData={props.formData}
				onChange={props.onChange}
				isValid={props.isValid}
				isSameContactNumber={props.isSameContactNumber}
				isResetSuccessful={props.isResetSuccessful}
				isNewDashBoardEnabled={props.isNewDashBoardEnabled}
				changeNumberLabels={props.changeNumberLabels}
			/>
		</CardBody>
	);
};

export default ChangeNumberTab;
